export default __webpack_public_path__ + "static/media/project-weatherapp.01c0365e.png";